import { render } from "./MenuEmpleado.vue?vue&type=template&id=60937cf2&scoped=true"
import script from "./MenuEmpleado.vue?vue&type=script&lang=js"
export * from "./MenuEmpleado.vue?vue&type=script&lang=js"

import "./MenuEmpleado.vue?vue&type=style&index=0&id=60937cf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60937cf2"]])

export default __exports__